exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.mint-product-details-modal-component .ant-modal-close-icon {\n  padding: 20px;\n}\n.mint-product-details-modal-component .ant-modal-body {\n  padding: 0;\n}\n", ""]);

// exports
